import {
  SIMPLE_FILES_FILTER,
  SIMPLE_FILES_FILTER_SUCCESS,
  SIMPLE_FILES_FILTER_ERROR,
  SIMPLE_FILES_SEGMENTS,
  SIMPLE_FILES_SEGMENTS_SUCCESS,
  SIMPLE_FILES_SEGMENTS_ERROR,
  SIMPLE_FILES_LIST,
  SIMPLE_FILES_LIST_SUCCESS,
  SIMPLE_FILES_LIST_ERROR,
  SIMPLE_FILES_DOWNLOAD,
} from "./actionTypes"

export const simpleFilesFilter = data => ({
  type: SIMPLE_FILES_FILTER,
  payload: data
});

export const simpleFilesFilterSuccess = data => ({
  type: SIMPLE_FILES_FILTER_SUCCESS,
  payload: {data}
});

export const simpleFilesFilterError = error => ({
  type: SIMPLE_FILES_FILTER_ERROR,
  payload: error,
});

export const simpleFilesSegments = data => ({
  type: SIMPLE_FILES_SEGMENTS,
  payload: data
});

export const simpleFilesSegmentsSuccess = data => ({
  type: SIMPLE_FILES_SEGMENTS_SUCCESS,
  payload: {data}
});

export const simpleFilesSegmentsError = error => ({
  type: SIMPLE_FILES_SEGMENTS_ERROR,
  payload: error,
});

export const simpleFilesList = data => ({
  type: SIMPLE_FILES_LIST,
  payload: data
});

export const simpleFilesListSuccess = data => ({
  type: SIMPLE_FILES_LIST_SUCCESS,
  payload: {data}
});

export const simpleFilesListError = error => ({
  type: SIMPLE_FILES_LIST_ERROR,
  payload: error,
});

export const simpleFilesDownload = data => ({
  type: SIMPLE_FILES_DOWNLOAD,
  payload: data
});
